import { uploadImageToS3 } from '@/utils/imageUtils';

export const downloadImageAsFile = async (url: string, fileName: string): Promise<File> => {
    const response = await fetch(url);
    if (!response.ok) {
        throw new Error(`Failed to download image (${response.status}): ${url}`);
    }
    const blob = await response.blob();
    return new File([blob], fileName, { type: blob.type || 'image/png' });
};

export const uploadRemoteImageToS3 = async (url: string): Promise<string> => {
    const fileName = url.split('/').pop()?.split('?')[0] || 'image.png';
    const file = await downloadImageAsFile(url, fileName);
    const uploaded = await uploadImageToS3('preview', file);
    return uploaded.Path;
};
